import Layout from '../../components/layout/Layout'
import { Link } from 'react-router-dom'
import blogPosts from '@/data/thoughts/posts.json'

const parsePostDate = (value: string) => {
  const timestamp = Date.parse(value)
  return Number.isNaN(timestamp) ? 0 : timestamp
}

const Blog = () => {
  const sortedPosts = [...blogPosts.posts].sort(
    (left, right) => parsePostDate(right.date) - parsePostDate(left.date)
  )

  return (
    <Layout>
      <div className="w-full max-w-4xl px-4 md:px-8 lg:px-12 py-8 md:py-10">
        <h1 className="text-4xl font-bold text-foreground mb-2">
          Blog
        </h1>
        <p className="text-sm text-muted-foreground mb-6 md:mb-8">
          All writing in one place.
        </p>

        <div className="divide-y divide-foreground/10">
          {sortedPosts.map((post) => (
            <article key={post.slug}>
              <Link
                to={post.slug}
                className="group -mx-2 px-2 py-4 block rounded-sm transition-colors hover:bg-foreground/[0.03]"
              >
                <div className="flex flex-col gap-1 md:flex-row md:items-baseline md:justify-between md:gap-6">
                  <h2 className="text-[1.72rem] md:text-[1.82rem] font-medium tracking-[-0.03em] leading-[1.15] [text-wrap:balance] text-foreground">
                    <span className="decoration-foreground/35 underline-offset-4 group-hover:underline">
                      {post.title}
                    </span>
                  </h2>
                  <time className="text-sm text-muted-foreground shrink-0 leading-normal md:text-right">
                    {post.date}
                  </time>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </Layout>
  )
}

export default Blog 
